import { Stack } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";

import type { IngredientGroupType } from "../../../common/types/recipeTypes";

import IngredientLine from "./IngredientLine";

type IngredientGroupProps = {
   ingredientGroup: IngredientGroupType;
   multiplier?: number;
};

const IngredientGroup = ({ ingredientGroup, multiplier = 1 }: IngredientGroupProps) => {
   const { name, ingredientLines } = ingredientGroup;

   return (
      <div>
         {!!name && <p className="text-sm font-semibold">{name}</p>}
         <Stack align="start" gap={0} className="divide-x-0 divide-y divide-solid divide-ink-border-subtle">
            {ingredientLines.map((ingredientLine, i) => (
               <IngredientLine
                  key={`${ingredientLine.ingredient.singular}-${i}`}
                  ingredientLine={ingredientLine}
                  multiplier={multiplier}
               />
            ))}
         </Stack>
      </div>
   );
};

export default observer(IngredientGroup);
